import LoaderWrapper from '@/components/ui/LoaderWrapper/LoaderWrapper.tsx';
import IsAdmin from '@/router/middleware/IsAdmin.tsx';
import NotLoggedIn from '@/router/middleware/NotLoggedIn.tsx';
import IsLoggedIn from '@/router/middleware/IsLoggedIn.tsx';

const middlewareConfig = {
  middlewaresMap: {
    notLoggedIn: <NotLoggedIn />,
    loggedIn: <IsLoggedIn />,
    admin: <IsAdmin />,
  },
  loader: <LoaderWrapper isLoading className="h-screen" />,
} as const;

export type MiddlewareType = keyof (typeof middlewareConfig)['middlewaresMap'];

export default middlewareConfig;
